// Reviews slider — horizontal swipe between review slides.
(function() {
  var track = document.querySelector('.hp-review-track');
  var slides = document.querySelectorAll('.hp-review-slide');
  var prev = document.querySelector('.hp-review-nav.hp-prev');
  var next = document.querySelector('.hp-review-nav.hp-next');
  if (!track || !slides.length || !prev || !next) return;
  var idx = 0;
  var count = slides.length;
  function show(i) {
    idx = ((i % count) + count) % count;
    track.style.transform = 'translateX(-' + (idx * 100) + '%)';
  }
  prev.addEventListener('click', function() { show(idx - 1); });
  next.addEventListener('click', function() { show(idx + 1); });
  var touchStartX = 0;
  var touchDeltaX = 0;
  track.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; touchDeltaX = 0; }, { passive: true });
  track.addEventListener('touchmove', function(e) { touchDeltaX = e.touches[0].clientX - touchStartX; }, { passive: true });
  track.addEventListener('touchend', function() { if (touchDeltaX > 50) show(idx - 1); else if (touchDeltaX < -50) show(idx + 1); });
  show(0);
})();

// Calendar Finder — 3 questions map to a Shopify collection
(function() {
  var finder = document.querySelector('.hp-finder');
  if (!finder) return;
  var answers = { who: null, priority: null, style: null };
  var step = 1;
  var stepEls = finder.querySelectorAll('.hp-finder-step');
  var resultEl = finder.querySelector('.hp-finder-result-box');
  var dots = finder.querySelectorAll('.hp-finder-dot');
  var resultsGrid = document.getElementById('finderResults');
  var headlineEl = finder.querySelector('.hp-finder-result-headline');
  var textEl = finder.querySelector('.hp-finder-result-text');

  var COLLECTIONS = {
    'kalender': { name: 'Familienplaner', desc: 'Der ganze Familien-Alltag auf einer Seite pro Monat – A3, viele Spalten, viel Platz.', img: 'https://cdn.shopify.com/s/files/1/0457/3469/0979/files/1_d8c9bd25-d76e-46ba-9450-af3329377e0a.jpg' },
    '3-spalten': { name: 'Paarplaner (3 Spalten)', desc: 'Für euch beide – jede Woche im Blick, Monat für Monat.', img: 'https://cdn.shopify.com/s/files/1/0457/3469/0979/files/1_e445bceb-6acc-4377-a0ac-e16465f662b4.jpg' },
    'a1-a2-grosse-wandplaner': { name: 'A1 Wandplaner', desc: 'Das ganze Jahr auf einen Blick – groß, klar, an der Wand.', img: 'https://cdn.shopify.com/s/files/1/0457/3469/0979/collections/15_9a4cde72-312f-48b5-8f2c-c8e0e96fce36.png' },
    'designkalender': { name: 'Big ONE Designkalender', desc: 'Wow-Statement für deine Wand – Design pur, monatlich neu.', img: 'https://cdn.shopify.com/s/files/1/0457/3469/0979/collections/A3_ATMO.png' },
    'fotokalender': { name: 'Fotokalender', desc: 'Deine Erinnerungen, Monat für Monat – zum selbst gestalten.', img: 'https://cdn.shopify.com/s/files/1/0457/3469/0979/collections/2021_1.jpg' },
    'a1-schuljahresplaner': { name: 'Schuljahresplaner', desc: 'Von September bis August – für Kinder und Familien, die im Schul-Rhythmus planen.', img: 'https://cdn.shopify.com/s/files/1/0457/3469/0979/files/5_a815a763-683c-4fe8-bce0-1b6d809271a0.jpg' },
    'grusskarten-postkarten': { name: 'Grußkarten & Mini-Karten', desc: 'Kleine Aufmerksamkeiten für jeden Anlass.', img: 'https://cdn.shopify.com/s/files/1/0457/3469/0979/collections/car_kleinekarte0.jpg' },
    'kalender-1': { name: 'Alle Kalender', desc: 'Schau dich in aller Ruhe um.', img: 'https://cdn.shopify.com/s/files/1/0457/3469/0979/files/HEAVENLY_HAND1_5698f937-da2e-4290-abdd-1b987061ec3f.jpg' }
  };

  function pickCollection(who, prio, style) {
    if (who === 'kid') return 'a1-schuljahresplaner';
    if (who === 'family') return 'kalender';
    if (who === 'couple' && prio !== 'yearview' && prio !== 'wow') return '3-spalten';
    if (prio === 'wow') return 'designkalender';
    if (prio === 'photos') return 'fotokalender';
    if (prio === 'yearview') return 'a1-a2-grosse-wandplaner';
    if (prio === 'monthly') {
      if (who === 'couple') return '3-spalten';
      return 'kalender';
    }
    if (who === 'gift') return 'grusskarten-postkarten';
    return 'kalender-1';
  }

  function renderResult() {
    var handle = pickCollection(answers.who, answers.priority, answers.style);
    var col = COLLECTIONS[handle] || COLLECTIONS['kalender-1'];
    if (headlineEl) headlineEl.textContent = col.name + ' passt zu dir.';
    if (textEl) textEl.textContent = col.desc;
    resultsGrid.style.gridTemplateColumns = '1fr';
    resultsGrid.style.maxWidth = '640px';
    resultsGrid.style.margin = '0 auto 48px';
    resultsGrid.innerHTML = '<a href="/collections/' + handle + '" style="display:grid;grid-template-columns:1fr 1fr;gap:24px;background:#fff;padding:20px;text-align:left;align-items:center">' +
      '<div style="aspect-ratio:1/1;overflow:hidden;background:#faf9f7"><img src="' + col.img + '" alt="' + col.name + '" style="width:100%;height:100%;object-fit:cover;display:block"></div>' +
      '<div>' +
        '<div class="hp-label" style="margin-bottom:8px">Deine Empfehlung</div>' +
        '<div style="font-family:var(--font-serif);font-size:22px;font-weight:400;margin-bottom:16px;line-height:1.2">' + col.name + '</div>' +
        '<span class="hp-cta-underline">Jetzt entdecken</span>' +
      '</div>' +
    '</a>';
  }

  function show(n) {
    stepEls.forEach(function(el) { el.classList.remove('hp-is-active'); });
    resultEl.classList.remove('hp-is-active');
    if (n === 'result') {
      resultEl.classList.add('hp-is-active');
      dots.forEach(function(d) { d.classList.add('hp-is-active'); });
      renderResult();
    } else {
      var target = finder.querySelector('.hp-finder-step[data-step="' + n + '"]');
      if (target) target.classList.add('hp-is-active');
      dots.forEach(function(d, i) { d.classList.toggle('hp-is-active', i < n); });
      step = n;
    }
  }

  finder.addEventListener('click', function(e) {
    var ansBtn = e.target.closest('.hp-finder-answer');
    var backBtn = e.target.closest('.hp-finder-back');
    var restartBtn = e.target.closest('.hp-finder-restart');
    if (ansBtn) {
      var v = ansBtn.dataset.value;
      if (step === 1) answers.who = v;
      else if (step === 2) answers.priority = v;
      else if (step === 3) answers.style = v;
      if (step < 3) show(step + 1);
      else show('result');
      return;
    }
    if (backBtn) { show(Number(backBtn.dataset.back)); return; }
    if (restartBtn) { answers.who = null; answers.priority = null; answers.style = null; show(1); }
  });
})();
